import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';
import { useI18n } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';

import { useMembershipAwarenessFormData } from '../../../formContext';
import { useMembershipAwarenessFormState } from '../../../formContext/formState';

type Result = ModelHookResult<
	{
		headlinePart1: string;
		headlinePart2: string;
		body: string;
		ctaQuestion: string;
		heroImage: string;
		heroImageAltText: string;
		paymentTerm: 'one-time' | 'monthly' | 'yearly';
		showYearlyPaymentTerm: boolean;
		showOneTimePaymentTerm: boolean;
	},
	{
		onChange: (value: string) => void;
	}
>;

type PaymentTerm = 'one-time' | 'monthly' | 'yearly';

export function useMembershipAwarenessPlacementConfig(): Result {
	const getStaticAssetUrl = useGetStaticAssetUrl();
	const { translate } = useI18n();
	const [{ paymentTerm }, { setPaymentTerm }] = useMembershipAwarenessFormState();
	const {
		data: {
			featureConfigs: { oneTimeContributionsEnabled, yearlyContributionsAmounts },
		},
	} = useMembershipAwarenessFormData();
	const track = useTracking();

	const onChange = (value: string) => {
		setPaymentTerm(value as PaymentTerm);
		void track('membership_ask_payment_term_selected', { payment_term: value });
	};
	return {
		data: {
			headlinePart1: translate('corgi.membership.awareness.headline_part1'),
			headlinePart2: translate('corgi.membership.awareness.headline_part2'),
			body: translate('corgi.membership.awareness.description'),
			ctaQuestion: translate('corgi.membership.awareness.ask'),
			heroImage: getStaticAssetUrl('/membership/main-image.png'),
			heroImageAltText: translate('corgi.membership.awareness.hero_image_alt_text'),
			showYearlyPaymentTerm: yearlyContributionsAmounts?.enabled ?? false,
			showOneTimePaymentTerm: oneTimeContributionsEnabled,
			paymentTerm,
		},
		actions: {
			onChange,
		},
	};
}
